export default "__VITE_ASSET__CDoz6Z9W__"